export default __webpack_public_path__ + "static/media/cta2.0d2afd7f.png";